import { render, staticRenderFns } from "./StringsListPopup.vue?vue&type=template&id=9c31d2ec&"
import script from "./StringsListPopup.vue?vue&type=script&lang=js&"
export * from "./StringsListPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports